import React from "react";
import { View, StyleSheet, ViewStyle, TextStyle } from "react-native";
import Text from "@components/CustomText";

interface TagProps {
  text: string;
  bgColor?: string;
  textColor?: string;
}

const Tag: React.FC<TagProps> = ({
  text,
  bgColor = "#FF0000",
  textColor = "#FFFFFF",
}) => {
  return (
    <View style={styles.wrapper}>
      <View style={[styles.container, { backgroundColor: bgColor }]}>
        <Text
          variant="caption_3"
          style={[
            {
              color: textColor,
              fontWeight: "bold",
              textAlign: "center",
              lineHeight: 16,
              top: -2,
            },
          ]}
        >
          {text}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 18,
    alignItems: "center",
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  wrapper: {
    alignSelf: "flex-start",
  },
});

export default Tag;
